import { Link, useLocation } from "react-router-dom";

function Navbar() {
  const location = useLocation();

  return (
    <header className="navbar">
      <nav className="navbar-nav">
        <Link to="/" className="logo">
          Grow<span className="logo-highlight">Grind</span>
        </Link>

        <div className="nav-links">
          <Link 
            to="/" 
            className={`nav-link ${location.pathname === '/' ? 'nav-link-active' : ''}`}
          >
            Accueil
          </Link>
          <Link 
            to="/contact" 
            className={`nav-link ${location.pathname === '/contact' ? 'nav-link-active' : ''}`}
          >
            Contact
          </Link>
        </div>
      </nav>
    </header>
  );
}

export default Navbar;
